import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { getImages } from './const';
import HeaderActions from './HeaderActions';

const inventoryMenuList = [
    {
        title: 'All Inventory',
        image: 'car-icon.png',
        link: '/cars-for-sale-florida-california/all'
    },
    {
        title: 'San Clemente, CA',
        image: 'header-ca.svg',
        link: '/cars-for-sale-florida-california/san-clemente'
    },
    {
        title: 'Tampa, FL',
        image: 'header-fl.svg',
        link: '/cars-for-sale-florida-california/tampa'
    },
]
const financeMenuList = [
    {
        title: 'Online Credit Approval',
        image: 'Online-Credit-Approval.png',
        link: ''
    },
    {
        title: 'Value Your Trade',
        image: 'Value-Your-Trade.png',
        link: ''
    },
    {
        title: 'Sell Your Vehicle',
        image: 'Sell-Your-Vehicle.png',
        link: ''
    },
]

const aboutMenuList = [
    {
        title: 'Company Reviews',
        image: 'company-reviews.png',
        link: '/european-exotic-center-customer-reviews'
    },
    {
        title: 'Our Team',
        image: 'our-team.png',
        link: '/european-exotic-center-staff'
    },
    {
        title: 'Consign',
        image: 'consign.png',
        link: '/consign-your-car'
    },
    {
        title: 'Car Finder',
        image: 'car-finder-sm.png',
        link: '/car-finder'
    },
    {
        title: 'Careers',
        image: 'careers.png',
        link: '/automotive-jobs'
    },
]
const Header = () => {
    const location = useLocation();
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu, setOpenSubMenu] = useState(false)
    const handleSubMenu = (menu) => {
        setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
    }
    const hoverHandleSubMenu = (menu) => {
        if (window.innerWidth > 1200) {
            setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
        }
    }
    const closeMenu = () => {
        setisMob(false);
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (type) => {
        setOpenDropdown(prev => (prev === type ? null : type));
    };
    const wrapperRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const [isHoveringMenu, setIsHoveringMenu] = useState(false);
    return (
        <>
            <header className='header-main-wrap'>
                <div className='header-wrap'>
                    <div className='container'>
                        <div className='d-flex align-items-center header-flex'>
                            <div className='main-logo'>
                                <Link to="/">
                                    <img src={getImages('eec-logo.png')} alt='European Exotic Center' />
                                </Link>
                            </div>
                            <div className={`d-flex align-items-center position-relative ms-md-auto main-menu ${isMob ? 'active' : ''}`}>
                                <div className='d-xl-none'>
                                    <HeaderActions
                                        wrapperRef={wrapperRef}
                                        hoverHandleSubMenu={hoverHandleSubMenu}
                                        openSubMenu={openSubMenu}
                                        handleSubMenu={handleSubMenu}
                                    />
                                </div>
                                <ul className='d-flex align-items-center'>
                                    <li>
                                        <NavLink to="/"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "active" : ""
                                            }
                                            onMouseEnter={() => {
                                                setIsHoveringMenu(true);
                                            }}
                                            onMouseLeave={() => {
                                                setIsHoveringMenu(false);
                                            }}
                                            onClick={closeMenu}
                                        >
                                            {isMob ? "Home" : <img style={{ verticalAlign: "-3px" }} src={getImages('header-home-icon.png')} alt='home' />}
                                        </NavLink>
                                    </li>
                                    <li className={`sub-menu ${openSubMenu === 'inventory' ? 'open' : ''}`}
                                        onMouseEnter={() => {
                                            hoverHandleSubMenu('inventory');
                                            setIsHoveringMenu(true);
                                        }}
                                        onMouseLeave={() => {
                                            hoverHandleSubMenu(null);
                                            setIsHoveringMenu(false);
                                        }}
                                    >
                                        <NavLink to="/cars-for-sale-florida-california"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "d-none d-xl-block active" : "d-none d-xl-block"
                                            }
                                        >Inventory <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='d-xl-none' onClick={() => handleSubMenu('inventory')}>Inventory <span className='menu-arrow-icon'></span></a>
                                        {/* {console.log("inventoryMenuList", inventoryMenuList)} */}
                                        <ul className='sub-mega-menu'>
                                            <li className='w-100'>
                                                <div className='row gx-0 sm-menu-row'>
                                                    {inventoryMenuList.map((item, index) =>
                                                        <div className='col-xl-4 col-12 text-center' key={index}>
                                                            <NavLink
                                                                key={index}
                                                                to={item.link}
                                                                end={item.link === "/cars-for-sale-florida-california"}  // only add `end` for base route
                                                                className={({ isActive }) =>
                                                                    "subm-col " + (isActive ? "active" : "")
                                                                }
                                                            >
                                                                <div className='mm-icon text-center mb-2'>
                                                                    <img src={getImages(item.image)} alt={item.title} />
                                                                </div>
                                                                <div className='xs-title text-uppercase'>{item.title}</div>
                                                            </NavLink>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <NavLink to="/sell-my-vehicle"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "active" : ""
                                            }
                                            onMouseEnter={() => {
                                                setIsHoveringMenu(true);
                                            }}
                                            onMouseLeave={() => {
                                                setIsHoveringMenu(false);
                                            }}
                                            onClick={closeMenu}
                                        >
                                            Sell Us Your Car
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/finance"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "active" : ""
                                            }
                                            onMouseEnter={() => {
                                                setIsHoveringMenu(true);
                                            }}
                                            onMouseLeave={() => {
                                                setIsHoveringMenu(false);
                                            }}
                                            onClick={closeMenu}
                                        >
                                            Finance
                                        </NavLink>
                                    </li>
                                    {/* <li className={`sub-menu ${openSubMenu === 'finance' ? 'open' : ''}`}
                                        onMouseEnter={() => {
                                            hoverHandleSubMenu('finance');
                                            setIsHoveringMenu(true);
                                        }}
                                        onMouseLeave={() => {
                                            hoverHandleSubMenu(null);
                                            setIsHoveringMenu(false);
                                        }}
                                    >
                                        <NavLink to="/finance"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "d-none d-xl-block active" : "d-none d-xl-block"
                                            }
                                        >Finance <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='d-xl-none' onClick={() => handleSubMenu('finance')}>Finance <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-mega-menu right-0 w-940'>
                                            <li className='w-100'>
                                                <div className='row gx-0 sm-menu-row'>
                                                    {financeMenuList.slice(0, 6).map((item, index) =>
                                                        <div className='col text-center' key={index}>
                                                            <a href="#" className='subm-col' onClick={closeMenu}>
                                                                <div className='mm-icon text-center mb-3'>
                                                                    <img src={getImages(item.image)} alt={item.title} />
                                                                </div>
                                                                <div className='xs-title text-uppercase'>{item.title}</div>
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        </ul>
                                    </li> */}
                                    <li className={`sub-menu ${openSubMenu === 'service' ? 'open' : ''}`}
                                        onMouseEnter={() => {
                                            hoverHandleSubMenu('service');
                                            setIsHoveringMenu(true);
                                        }}
                                        onMouseLeave={() => {
                                            hoverHandleSubMenu(null);
                                            setIsHoveringMenu(false);
                                        }}
                                    >
                                        <NavLink to="/car-service-in-tampa-fl"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "d-none d-xl-block active" : "d-none d-xl-block"
                                            }
                                        >Service <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='d-xl-none' onClick={() => handleSubMenu('service')}>
                                            <div className='d-flex d-xl-block justify-content-between'>
                                                <div>Service</div>
                                                <div className='mm-mob-location'>
                                                    <img className='me-1' src={getImages('sm-locaton-icon.png')} alt='location' /> Tampa Only
                                                </div>
                                            </div>
                                            <span className='menu-arrow-icon'></span>
                                        </a>
                                        <ul className='sub-mega-menu right-0 w-940 smm-pd'>
                                            <li className='w-100'>
                                                <div className='row sm-menu-row'>
                                                    <div className='col-md-5 pe-xl-5 d-xl-block d-none'>
                                                        <div>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='me-3'>
                                                                    <img src={getImages('location-icon.png')} alt='location' />
                                                                </div>
                                                                <div className='md-title'>Service - <span className='text-orange'>Tampa Only</span></div>
                                                            </div>
                                                            <div className='xs-title font-13 my-2'>7817 N Dale Mabry Hwy Tampa, FL 33614</div>
                                                            <div className='xs-title fw-500 avenir-next mb-2'>(813) 578-4192</div>
                                                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.1658352195077!2d-82.5044729!3d28.019406800000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e50bf9dc0def%3A0x1641769292fc877f!2sEuropean%20Exotic%20Center!5e0!3m2!1sen!2sin!4v1758121637702!5m2!1sen!2sin" width="100%" height="127" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
                                                            <iframe src="https://snazzymaps.com/embed/739247" width="100%" height="127px" style={{ border: 'none' }}></iframe>
                                                            <div>
                                                                <a href="https://maps.app.goo.gl/8opCErm85YUk63Bj9" target="_blank" className='xs-title font-13 text-orange fw-500 avenir-next d-inline-block'>Get Directions</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col ps-xl-5 col-border-left d-xl-block d-none'>
                                                        <div className='mb-4 mt-3'>
                                                            <Link to='/car-service-in-tampa-fl' className='black-red-btn mnw-200 text-uppercase d-inline-block' onClick={closeMenu}>Our Services</Link>
                                                        </div>
                                                        <div className='mb-4 mt-3'>
                                                            <Link to='/car-service-in-tampa-fl' state={{ openModal: true }} className='black-red-btn mnw-200 text-uppercase d-inline-block' onClick={closeMenu}>Schedule Service</Link>
                                                        </div>
                                                        <div>
                                                            <Link to='/detailing' state={{ openModal: true }} className='black-red-btn mnw-200 text-uppercase d-inline-block' onClick={closeMenu}>Detailing</Link>
                                                        </div>
                                                    </div>
                                                    <div className='col ps-xl-4 pt-xl-0 pt-0'>
                                                        <div>
                                                            <ul className='service-mm-menu'>
                                                                <li className='d-xl-none'><Link to='/car-service-in-tampa-fl' onClick={closeMenu}>Our Services</Link></li>
                                                                <li className='d-xl-none'><Link to='/car-service-in-tampa-fl' state={{ openModal: true }}>Schedule Service</Link></li>
                                                                <li className='d-xl-none'><Link to='/detailing' onClick={closeMenu}>Detailing</Link></li>
                                                                <li className='d-xl-none'><hr className='cs-hr my-3' /></li>
                                                                <li><Link to='/ferrari-repair' onClick={closeMenu}>Ferrari Service</Link></li>
                                                                <li><Link to='/lamborghini-repair' onClick={closeMenu}>Lamborghini Service</Link></li>
                                                                <li><Link to='/porsche-repair' onClick={closeMenu}>Porsche Service</Link></li>
                                                                {/* <li><Link to='/maserati-repair' onClick={closeMenu}>Maserati Service</Link></li> */}
                                                                <li><Link to='/aston-martin-repair' onClick={closeMenu}>ASTON MARTIN SERVICE</Link></li>
                                                                <li><Link to='/mclaren-repair' onClick={closeMenu}>McLaren Service</Link></li>
                                                                <li><Link to='/classic-car-repair' onClick={closeMenu}>Classic Car Service</Link></li>
                                                                <li><Link to='/audi-r8-repair' onClick={closeMenu}>Audi R8 Service</Link></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={`sub-menu ${openSubMenu === 'aboutUs' ? 'open' : ''}`}
                                        onMouseEnter={() => {
                                            hoverHandleSubMenu('aboutUs');
                                            setIsHoveringMenu(true);
                                        }}
                                        onMouseLeave={() => {
                                            hoverHandleSubMenu(null);
                                            setIsHoveringMenu(false);
                                        }}
                                    >
                                        <NavLink to="/about-european-exotic-center"
                                            className={({ isActive }) =>
                                                isActive && !isHoveringMenu ? "d-none d-xl-block active" : "d-none d-xl-block"
                                            }
                                        >About Us <span className='menu-arrow-icon'></span></NavLink>
                                        <a href="#" className='d-xl-none' onClick={() => handleSubMenu('aboutUs')}>About Us <span className='menu-arrow-icon'></span></a>
                                        <ul className='sub-mega-menu right-0 w-940'>
                                            <li className='w-100'>
                                                <div className='row gx-0 sm-menu-row'>
                                                    {aboutMenuList.map((item, index) =>
                                                        <div className='col text-center' key={index}>
                                                            <NavLink to={item.link} className='subm-col' onClick={closeMenu}>
                                                                <div className='mm-icon text-center mb-3'>
                                                                    <img src={getImages(item.image)} alt={item.title} />
                                                                </div>
                                                                <div className='xs-title text-uppercase'>{item.title}</div>
                                                            </NavLink>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <div className='d-none d-xl-flex ms-md-5'>
                                    <HeaderActions
                                        wrapperRef={wrapperRef}
                                        hoverHandleSubMenu={hoverHandleSubMenu}
                                        openSubMenu={openSubMenu}
                                        handleSubMenu={handleSubMenu}
                                    />
                                </div>
                            </div>
                            <div className={`overflow-bg d-xl-none ${isMob ? 'active' : ''
                                }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                            <div
                                className={`mobile-inner-header ms-auto d-xl-none ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            >
                                <div
                                    className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                        }`}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header